

import templateCartButton from '@/app-template/lib/components/CartButton.vue';

export default {
  components: { templateCartButton },
};
